module.exports = __webpack_public_path__ + "static/media/comment.7eda1838.svg";